<!--
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2022-01-18 11:37:25
 * @LastEditors: voanit
 * @LastEditTime: 2022-01-20 15:09:05
-->
<template>
  <div class="message-wrap">
    <div class="message-header__wrap">
      <div class="message-header">
        <span>消息通知</span>
        <span @click="toMessageCenter" class="message-more">{{ $t('system::common::dialog::message_more') }}</span>
      </div>
    </div>
    <div class="message-list">
      <div
        @click="toMessageCenter(item)"
        class="message-item__wrap"
        :class="{ 'not-read': !item.status }"
        v-for="item in messageList"
        :key="item.id"
      >
        <div class="message-item">
          <div class="message-title__wrap">
            <div class="message-title one-line" :class="{ 'have-read': item.status }">
              [{{ typeMap[item.messageType] }}] {{ item.header }}
            </div>
            <div class="message-time" :class="{ 'have-read': item.status }">{{ item.pushTime }}</div>
          </div>
          <div class="message-content more-line" :class="{ 'have-read': item.status }">
            {{ item.message }}
          </div>
        </div>
      </div>
      <default-data v-show="!messageList.length" :custom="{ text: '暂无消息' }" style="height: 200px"></default-data>
    </div>
    <ShowDetail v-model="visible" :message="message"></ShowDetail>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { _local } from '@/utils/storage'
import { setMessageRead } from '@/server/message'

import ShowDetail from '@/views/message-center/components/showDetail.vue'
import './header-message'
export default {
  components: { ShowDetail },
  data() {
    return {
      typeMap: {
        0: '公告',
        1: '系统',
      },
      visible: false,
      message: {},
    }
  },
  async created() {
    await Promise.all([this.$store.dispatch('getMessageList'), this.$store.dispatch('getUnreadTotal')])
  },
  mounted() {
    window.eventBus.$on('notice', obj => {
       if (!obj.status) {
          this.signRead(obj.id)
        }
      this.message = obj
      this.visible = true
    })
  },
   methods: {
    async toMessageCenter(item) {
      // 公告直接打开，系统消息跳转
      if (item.messageType === 0) {
        window.eventBus.$emit('notice', item)
      } else {
        const token = Cookies.get('saasToken') || _local.get('saasToken')
        const url = process.env.VUE_APP_ACCOUNT_URL
        console.log(url)
        window.location.href = `${url}/my-message?token=${token}`
      }
    },
    async signRead(id) {
      const { data } = await setMessageRead([id])
      if (data.code === this.$code) {
        Promise.all([this.$store.dispatch('getMessageList'), this.$store.dispatch('getUnreadTotal')])
      }
    },
  },
  computed: {
    messageList() {
      return (this.$store.state.headerMessage && this.$store.state.headerMessage.messageList) || []
    },
  },
}
</script>

<style lang="scss" scoped>
.message-wrap {
  width: 398px;
  max-height: 488px;
  background: #ffffff;
  box-shadow: 0px 12px 25px 0px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: auto;
  cursor: default;
  padding-bottom: 15px;
  .message-header__wrap {
    padding: 0 30px;
    .message-header {
      height: 52px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      font-weight: 600;
      color: rgba(1, 5, 23, 0.75);
      border-bottom: 1px solid #ebebeb;
      .message-more {
        font-size: 12px;
        font-weight: 400;
        color: rgba(1, 5, 23, 0.45);
        cursor: pointer;
        &:hover {
          color: #0560fd;
        }
      }
    }
  }
  .message-list {
    padding: 0 6px;
    .message-item__wrap {
      position: relative;
      padding: 0 24px;
      cursor: pointer;
      .message-item {
        padding: 15px 0 11px;
        border-bottom: 1px solid #f7f7f7;
        box-sizing: border-box;
        .message-title__wrap {
          display: flex;
          justify-content: space-between;
          margin-bottom: 8px;
          .message-title {
            max-width: 203px;
            font-size: 12px;
            font-weight: 600;
            color: rgba(1, 5, 23, 0.75);
            &.have-read {
              color: rgba(1, 5, 23, 0.25);
            }
          }
          .message-time {
            font-size: 12px;
            font-weight: 400;
            color: rgba(1, 5, 23, 0.45);
            &.have-read {
              color: rgba(1, 5, 23, 0.25);
            }
          }
        }
        .message-content {
          max-width: 336px;
          font-size: 12px;
          font-weight: 400;
          color: rgba(1, 5, 23, 0.45);
          line-height: 17px;
          &.have-read {
            color: rgba(1, 5, 23, 0.25);
          }
        }
      }
      &:hover {
        background: #f7f7f7;
        .message-item {
          border-bottom: 1px solid #f7f7f7;
          .message-title {
            color: #0560fd;
          }
        }
      }
      &.not-read::after {
        content: ' ';
        position: absolute;
        top: 20px;
        left: 5px;
        width: 6px;
        height: 6px;
        background: #f93000;
        border-radius: 50%;
      }
    }
  }
}
</style>
